import type { NoticeComposition, NoticeProof } from './notice-fidelity.models';
import { noticeReferenceSelections } from './notice-reference-commands';

/** Older compatible renderers may omit inspection evidence; never invent it. */
export function matchNoticeReferenceEvidence(proof: NoticeProof): boolean {
  if (proof.referenceEvidence == null) return true;
  if (!Array.isArray(proof.referenceEvidence)) return false;
  try {
    const document: NoticeComposition = JSON.parse(proof.sourceJson);
    const expected = document.blocks.flatMap(noticeReferenceSelections);
    if (expected.length !== proof.referenceEvidence.length) return false;
    let textLength = 0;
    return proof.referenceEvidence.every((item, index) => {
      const selection = expected[index];
      if (
        !item ||
        typeof item !== 'object' ||
        Array.isArray(item) ||
        item.blockId !== selection.blockId ||
        item.referenceIndex !== selection.referenceIndex ||
        item.kind !== selection.kind ||
        item.code !== selection.code ||
        item.format !== selection.format ||
        typeof item.text !== 'string' ||
        !/^[\t\n\r\x20-\x7e]*$/.test(item.text)
      )
        return false;
      textLength += item.text.length;
      return textLength <= 64000;
    });
  } catch {
    return false;
  }
}
